<template lang="pug" src="./modal-community.pug"></template>

<script>
import Icon from 'components/icon/icon'

export default {
  props: ['props'],
  data () {
    return {
      active: 0
    }
  },
  methods: {
    close () {
      this.$store.dispatch('COMMUNITY_MODAL', false)
    },
    slider (e) {
      if (e === 'prev') { this.active === 0 ? this.active = (this.props.gallery.length - 1) : this.active-- }
      if (e === 'next') { this.active === (this.props.gallery.length - 1) ? this.active = 0 : this.active++ }
    }
  },
  components: {
    Icon
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modal/modal-community/modal-community.vue